<template>
  <f7-page>
    <notifications
      class="position-absolute d-flex float-right w-100 global-notification"
      eventName="mainNotif"/>
    <document-main-view v-if="!isHidden" :documents="documents">
    </document-main-view>
    <div v-if="showUBO">
      <div :style="!isHidden ? 'padding: 0 15px 15px 15px;' : ''">
        <button @click="isHidden = !isHidden" v-if="!isHidden" type="button" class="btn-declare">
          {{ $t('iframe_page.doctypes.complete_declaration') }}
        </button>
      </div>
      <document-ubo-view v-if="isHidden" @update:parent="isHidden = false" :keys="reloadComponent" :ubos="ubos">
      </document-ubo-view>
      <!-- {{ubos}} -->
    </div>
  </f7-page>
</template>
<script>

import DocumentMainView from './components/DocumentMainView.vue'
import HeaderBack from './components/HeaderBack.vue'
import DocumentUboView from './components/DocumentUboView.vue'
import Notifications from '@/components/common/notifications.vue'

/** @author TLV 08/02/2021
* @brief Formulaire intégré en iframe sur une autre application pour envoyer des
*       documents de paiement
*/
export default {
  name: 'SendDocumentsFromApplicationForm',
  components: {
    'document-main-view': DocumentMainView,
    'document-ubo-view': DocumentUboView,
    'notifications': Notifications,
    'header-back': HeaderBack
  },
  data () {
    return {
      idSeller: '-1',
      documents: [],
      ubos: [],
      userTmpSIREN: '',
      isHidden: false,
      reloadComponent: false,
      showUBO: false
    }
  },
  created () {
    let that = this
    if (this.$engine.user.get().IdSeller) {
      that.$engine.services.suppliers.getDocuments(this.$engine.user.get().IdSeller)
      .then(resp => {
        if (resp && resp.data && resp.data.Sellers && resp.data.Sellers.length) {
          that.$engine.services.suppliers.selectedSupplier = resp.data.Sellers[0]
          that.documents = resp.data.Sellers[0].Documents
          that.ubos = resp.data.Sellers[0].UBO
        }
        that.reloadComponent = true
        that.$f7.hidePreloader()
      })
      .catch(err => {
        that.$f7.hidePreloader()
        console.log(err)
      })
    } else {
      this.$engine.services.suppliers.update('2')
      .then(resp => {
        if (resp && resp.data && resp.data.Sellers && resp.data.Sellers.length) {
          that.userTmpSIREN = resp.data.Sellers[0].Siret
          that.idSeller = resp.data.Sellers[0].IdSeller
          that.$engine.services.suppliers.getDocuments(that.idSeller)
          .then(resp2 => {
            if (resp2 && resp2.data && resp2.data.Sellers && resp2.data.Sellers.length) {
              that.$engine.services.suppliers.selectedSupplier = resp2.data.Sellers[0]
              that.documents = resp2.data.Sellers[0].Documents
              that.ubos = resp2.data.Sellers[0].UBO
            }
            that.reloadComponent = true
            that.$f7.hidePreloader()
          })
          .catch(err => {
            that.$f7.hidePreloader()
            console.log(err)
          })
        } else {
          that.$f7.hidePreloader()
        }
      })
      .catch(err => {
        that.$f7.hidePreloader()
        console.log(err)
      })
    }
  },
  mounted () {
    // this.$bus.$emit('mainNotif', { text: this.$t('iframe_page.valid_documents_1') + this.$t('iframe_page.valid_documents_2') })
    // this.$bus.$emit('mainNotif', { text: 'Ceci est un test' })
  },
  methods: {
    returnToMainView () {
      this.isHidden = false
    }
  }
}
</script>
<style scoped>
.global-notification {
  bottom:0;
  z-index:10070;
  position:fixed !important;
}
.document_type_name {
  font-size: 16px;
  line-height: 18px;
  font-weight: 400;
  color: black;
}
/* Ajouts sur selectionBloc utiles uniquement sur ce component (pas sur Shareholder) */
.selectionBloc {
  margin-top: 15px;
  width: 100%;
}
.information_check {
  color: red;
}
.information_check_no {
  color: #49A0A2;
}
.btn-declare {
  background: #1B1918;
  border-radius: 2px;
  font-weight: 500;
  font-size: 16px;
  line-height: 28px;
  text-align: center;
  color: #FFFFFF;
  height: 36px;
  width: 100%;
  border: none;
}
</style>
